import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";

/**
 * InfoBoard 3 Yta
 */
class InfoBoard3 extends Component {
    initialValuesLoaded = false;

    handleInput = (name, event) => {
        let { value } = event.target;

        if (
            name == "numDynamicRows" &&
            !isNaN(value) &&
            parseFloat(value) > 10
        ) {
            // Limit to ten dynamic rows
            value = 10;
        }

        if (event.target.value == "") {
            this.setState({
                [name]: ""
            });
            return;
        }

        this.setState({
            [name]: isNaN(value) ? value : parseFloat(value)
        });
    };

    handleBlur = () => {
        let area = 0;
        let lapsize = "";
        let usage = 0;
        let circumference = 0;
        let objectsPerRow = 0;

        let {
            height,
            printWidth,
            printHeight,
            overlap,
            bleed,
            mode
        } = this.state;

        let lastRenderedSize =
            this.state.dynRowsTotalAreaWithWaste +
            " " +
            this.state.materialArea;

        let { width: materialWidth } = this.state.originalArticle;

        printWidth = parseFloat(printWidth);
        printHeight = parseFloat(printHeight);
        height = parseFloat(height);
        materialWidth = parseFloat(materialWidth);
        overlap = isNaN(overlap) ? 0 : parseFloat(overlap);
        bleed = isNaN(bleed) ? 0 : parseFloat(bleed);

        if (!this.initialValuesLoaded) {
            this.recalculateAllDynamicRows();
            return;
        }

        // Stående = 0, liggande = 1
        let wmm = 0;
        let hmm = 0;
        let minw = materialWidth;

        wmm = parseFloat(printHeight);
        hmm = parseFloat(printWidth);

        var laps = 1;

        // Add bleed
        wmm += bleed * (laps * 2);
        hmm += bleed * 2;

        let w = wmm / 1000;
        let h = hmm / 1000;

        area = parseFloat((w * h).toFixed(4));

        circumference = Math.ceil((w * 2 + h * 2) * 10) / 10;
        let circTotal =
            Math.ceil(((Math.floor(wmm / laps) * 2 + hmm * 2) * laps) / 100) /
            10;

        // How many can we fit before we have to start on a new row?
        let usedWidthPercent = 0;
        let joint = Math.ceil(hmm * (laps - 1)) / 1000;

        let amountPerRow = Math.floor(minw / printWidth);
        amountPerRow = amountPerRow > 1 ? amountPerRow : 1;

        let printWidthWithOverlapAndBleed = printWidth;

        if (laps > 1) {
            printWidthWithOverlapAndBleed =
                printWidth + overlap * laps + bleed * laps * 2;
        } else {
            printWidthWithOverlapAndBleed += bleed * 2;
        }

        usedWidthPercent = Math.round(
            (((printWidthWithOverlapAndBleed * amountPerRow) / minw) *
                100) /
            laps
        );

        usage = isNaN(usedWidthPercent) ? "" : usedWidthPercent + "%";

        let circumferenceTotal = circTotal > 0 ? circTotal : 0;

        if (Math.floor(wmm / laps) > 0) {
            lapsize = Math.floor(wmm / laps) + "x" + hmm;
            objectsPerRow =
                Math.floor(minw / wmm) > 1 ? Math.floor(minw / wmm) : 1;
        } else {
            lapsize = "0x" + hmm;
            objectsPerRow = 1;
        }

        let materialArea = 0;

        if (minw > 0) {
            materialArea = (minw / 1000) * h * laps;
        } else {
            materialArea = w * h;
        }

        materialArea = parseFloat(materialArea.toFixed(4));

        this.setState(
            {
                area,
                materialArea,
                laps,
                lapsize,
                overlap,
                usage,
                circumference,
                circumferenceTotal,
                joint,
                objectsPerRow,
                mode,
                lastRenderedSize
            },
            () => {
                this.updateParent();
            }
        );
    };

    renderDynamicRows = () => {
        let {
            numDynamicRows,
            rows,
            dynRowsTotalCircumference,
            dynRowsTotalArea,
            dynRowsTotalAreaWithWaste
        } = this.state;
        const { isEditable } = this.props;
        const tableHeadings = [
            { name: "Antal", align: "left", width: "5%" },
            { name: "Bas i mm", align: "left", width: "10%" },
            { name: "Höjd i mm", align: "left", width: "5%" },
            { name: "Omkrets lpm", align: "left", width: "5%" },
            { name: "Yta i m2", align: "left", width: "5%" }
        ];

        if (
            "undefined" == typeof numDynamicRows ||
            isNaN(parseInt(numDynamicRows))
        ) {
            return null;
        }

        numDynamicRows = parseInt(numDynamicRows);

        while (rows.length <= 10) {
            rows.push({ amount: 0, width: 0, height: 0 });
        }

        let outputRows = [];
        for (let i = 0; i <= numDynamicRows - 1; i++) {
            outputRows.push(rows[i]);
        }

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        {tableHeadings.map(heading => {
                            return (
                                <div
                                    key={heading.name}
                                    className={
                                        "form-group mr-1 limitSize text-" +
                                        heading.align
                                    }
                                >
                                    {heading.name}
                                </div>
                            );
                        })}
                        {isEditable && <div>&nbsp;</div>}
                    </div>
                </div>

                {outputRows.map((row, index) => (
                    <Row
                        index={index}
                        isEditable={isEditable}
                        key={index}
                        onChangeRow={(name, event) =>
                            this.handleChangeDynamicRow(index, name, event)
                        }
                        row={row}
                    />
                ))}

                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className="form-group mr-1 limitSize">
                            <label>Total omkrets lpm</label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-circumference js-totalCircumference"
                                value={dynRowsTotalCircumference || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total yta m<sup>2</sup>
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-orderedAreaM2"
                                value={dynRowsTotalArea || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total m<sup>2</sup> inkl spill
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-materialAreaM2"
                                value={dynRowsTotalAreaWithWaste || 0}
                                disabled
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    recalculateAllDynamicRows = () => {
        const { rows } = this.state;
        for (let i = 0; i < rows.length; i++) {
            rows[i] = this.calculateDynamicRowFields(rows[i]);
        }

        this.setState({ rows }, () => this.calculateDynamicRowsTotal());
    };

    handleWasteChange = (name, event) => {
        let { value } = event.target;

        this.setState(
            {
                [name]: isNaN(value) || value == "" ? "" : parseFloat(value)
            },
            () => {
                this.recalculateAllDynamicRows();
            }
        );
    };

    calculateDynamicRowsTotal = () => {
        const { rows, numDynamicRows } = this.state;
        const waste = isNaN(parseFloat(this.state.waste))
            ? 0
            : parseFloat(this.state.waste);
        const wasteMultiplier = isNaN(parseFloat(waste))
            ? 1
            : 1 + parseFloat(waste) / 100;
        let dynRowsTotalCircumference = 0;
        let dynRowsTotalArea = 0;

        for (let i = 0; i < numDynamicRows; i++) {
            dynRowsTotalCircumference += parseFloat(rows[i]["circumference"]);
            dynRowsTotalArea += parseFloat(rows[i]["area"]);
        }

        if (isNaN(dynRowsTotalCircumference) || isNaN(dynRowsTotalArea)) return;

        dynRowsTotalCircumference = parseFloat(
            dynRowsTotalCircumference.toFixed(4)
        );
        dynRowsTotalArea = parseFloat(dynRowsTotalArea.toFixed(4));

        let dynRowsTotalAreaWithWaste = parseFloat(
            (dynRowsTotalArea * wasteMultiplier).toFixed(4)
        );

        this.setState(
            {
                dynRowsTotalCircumference,
                dynRowsTotalArea,
                dynRowsTotalAreaWithWaste
            },
            () => {
                this.updateParent();
            }
        );
    };

    updateParent = () => {
        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const {
            // mode,
            quantity,
            dynRowsTotalAreaWithWaste,
            materialArea,
            objectsPerRow,
            lastRenderedSize
        } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (
                lastRenderedSize !=
                dynRowsTotalAreaWithWaste + " " + materialArea
            ) {
                onChange(
                    id,
                    "quantity",
                    dynRowsTotalAreaWithWaste,
                    "infoboard"
                );
                onChange(id, "clear_dont_recalculate_flag");
            }
        }

        onChange(id, "height", "-");
        onChange(id, "objectsPerRow", objectsPerRow);
    };

    handleChangeDynamicRow = (index, name, event) => {
        const { rows } = this.state;
        let thisRow = { ...rows[index] };

        thisRow[name] = event.target.value;

        rows[index] = this.calculateDynamicRowFields(thisRow);

        this.setState({ rows }, () => {
            this.calculateDynamicRowsTotal();
        });
    };

    calculateDynamicRowFields = originalRow => {
        const row = { ...originalRow };
        const width = isNaN(parseFloat(row["width"]))
            ? 0
            : parseFloat(row["width"]);
        const height = isNaN(parseFloat(row["height"]))
            ? 0
            : parseFloat(row["height"]);
        const amount = isNaN(parseFloat(row["amount"]))
            ? 0
            : parseFloat(row["amount"]);

        if (width * height * amount == 0) {
            row.circumference = 0;
            row.area = 0;
        } else {
            row.circumference = parseFloat(
                (((width * 2 + height * 2) / 1000) * amount).toFixed(4)
            );
            row.area = parseFloat(
                ((width * height * amount) / 1000000).toFixed(4)
            );
        }

        return row;
    };

    getPopulatedData() {
        const { data, extendedData, globalSettings } = this.props;

        if (extendedData.printHeight) {
            let printHeight = parseFloat(extendedData.printHeight);
            if (isNaN(printHeight)) {
                printHeight = 0;
            }
            data.printHeight = printHeight;
        } else {
            data.printHeight = 0;
        }

        if (extendedData.bleed) {
            let bleed = parseInt(extendedData.bleed);
            if (isNaN(bleed)) {
                bleed = globalSettings.bleed;
            }
            data.bleed = bleed;
        } else {
            data.bleed = globalSettings.bleed;
        }

        if (extendedData.numDynamicRows) {
            let numDynamicRows = parseInt(extendedData.numDynamicRows);
            if (isNaN(numDynamicRows)) {
                numDynamicRows = 1;
            }
            data.numDynamicRows = numDynamicRows;
        } else {
            data.numDynamicRows = 1;
        }

        if (extendedData.waste) {
            let waste = parseInt(extendedData.waste);
            if (isNaN(waste)) {
                waste = globalSettings.waste;
            }
            data.waste = waste;
        } else {
            data.waste = globalSettings.waste;
        }

        if (extendedData.overlap) {
            let overlap = parseInt(extendedData.overlap);
            if (isNaN(overlap)) {
                overlap = globalSettings.overlap;
            }
            data.overlap = overlap;
        } else {
            data.overlap = globalSettings.overlap;
        }

        data.printDirection = 1;
        data.mode = "multi";

        if (extendedData.printWidth) {
            let printWidth = parseFloat(extendedData.printWidth);
            if (isNaN(printWidth)) {
                printWidth = 0;
            }
            data.printWidth = printWidth;
        } else {
            data.printWidth = 0;
        }

        data.rows =
            extendedData.rows && extendedData.rows.length > 0
                ? extendedData.rows
                : [];

        return data;
    }

    renderFields = () => {
        const { mode } = this.state;

        return (
            <Fragment>
                {this.renderMultiObjectFields()}
            </Fragment>
        );
    };

    renderMultiObjectFields = () => {
        const { numDynamicRows, waste } = this.state;
        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1 limitSize">
                                    <label>Antal rader</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "numDynamicRows",
                                            onChange: event =>
                                                this.handleInput(
                                                    "numDynamicRows",
                                                    event
                                                ),
                                            onBlur: () => this.handleBlur(),
                                            value: numDynamicRows
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={numDynamicRows}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1 limitSize">
                                    <label>Spill i %</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "waste",
                                            onChange: event =>
                                                this.handleWasteChange("waste", event),
                                            value: waste
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={waste}
                                        />
                                    )}
                                </div>
                                {InfoBoardHelper.renderHiddenInput({
                                    name: "infoboardType",
                                    value: 3
                                })}
                            </div>
                        </div>
                        {this.renderDynamicRows()}
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p><b>Infoboard - Yta</b><br />
                                Infoga antal och storlek i varje rad du valt. Ändra spill i % för uppskattad spill åtgång.</p>
                            <p>Artiklar som du vill koppla till Infoboardsvärden dras in med flyttknappen.
                            Dra artikelraden till höger, den kopplas automatiskt till vald infoboardsdata och färgas grön.</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    constructor(props) {
        super(props);
        // Populate with previously saved data
        const data = this.getPopulatedData();
        this.state = data;
    }

    componentDidMount() {
        this.handleBlur();
    }

    render() {
        const { sortIndex } = this.props;
        InfoBoardHelper.sortIndex = sortIndex;

        return <InfoBoard>{this.renderFields()}</InfoBoard>;
    }
}

class Row extends Component {
    render() {
        const { index, isEditable, row } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][amount]",
                                    onChange: event =>
                                        this.props.onChangeRow("amount", event),
                                    value: row.amount
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.amount}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][width]",
                                    onChange: event =>
                                        this.props.onChangeRow("width", event),
                                    value: row.width
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.width}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][height]",
                                    onChange: event =>
                                        this.props.onChangeRow("height", event),
                                    value: row.height
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.height}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][circumference]"}
                                value={row.circumference || 0}
                                disabled
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][area]"}
                                value={row.area || 0}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InfoBoard3;
